import { useEffect, useState } from 'react'
import { api, ApiFehler } from './api'
import { Anmeldung } from './bereiche/Anmeldung'
import { Benutzer } from './bereiche/Benutzer'
import { Buchungen } from './bereiche/Buchungen'
import { Dauerauftraege } from './bereiche/Dauerauftraege'
import { Konten } from './bereiche/Konten'
import { MailLink, mailLinkAusUrl } from './bereiche/MailLink'
import { Profil } from './bereiche/Profil'
import { Protokoll } from './bereiche/Protokoll'

const tabs = [
  { id: 'buchungen', titel: 'Buchungen' },
  { id: 'konten', titel: 'Konten' },
  { id: 'dauerauftraege', titel: 'Daueraufträge' },
  { id: 'protokoll', titel: 'Protokoll' },
  { id: 'benutzer', titel: 'Benutzer', nurAdmin: true },
  { id: 'profil', titel: 'Profil', versteckt: true },
] as const
type TabId = (typeof tabs)[number]['id']

function tabAusHash(): TabId {
  const h = window.location.hash.substring(1)
  return tabs.some((t) => t.id === h) ? (h as TabId) : 'buchungen'
}

export function App() {
  const [ich, setIch] = useState<{ benutzername: string; rollen: string[] } | null | undefined>(undefined)
  const [tab, setTab] = useState<TabId>(tabAusHash)
  const [mailLink, setMailLink] = useState(mailLinkAusUrl)

  const pruefen = () =>
    api
      .ich()
      .then(setIch)
      .catch((e) => {
        if (e instanceof ApiFehler && e.status === 401) setIch(null)
        else throw e
      })

  useEffect(() => {
    pruefen()
    const onHash = () => setTab(tabAusHash())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  if (mailLink)
    return (
      <MailLink
        link={mailLink}
        onFertig={() => {
          setMailLink(null)
          pruefen()
        }}
      />
    )
  if (ich === undefined) return null
  if (ich === null) return <Anmeldung onAngemeldet={pruefen} />

  const admin = ich.rollen.includes('ADMIN')
  const sichtbar = tabs.filter((t) => !('versteckt' in t) && (!('nurAdmin' in t) || admin))
  const aktiv = tab === 'benutzer' && !admin ? 'buchungen' : tab

  return (
    <div className="app">
      <header>
        <h1>Dolly</h1>
        <nav>
          {sichtbar.map((t) => (
            <a key={t.id} href={`#${t.id}`} className={t.id === aktiv ? 'aktiv' : undefined}>
              {t.titel}
            </a>
          ))}
        </nav>
        <span className="benutzer">
          <a href="#profil" className={aktiv === 'profil' ? 'aktiv' : undefined} title="Profil">
            {ich.benutzername}
          </a>{' '}
          <button className="link" onClick={() => api.abmelden().then(() => setIch(null))}>
            Abmelden
          </button>
        </span>
      </header>
      <main>
        {aktiv === 'buchungen' && <Buchungen />}
        {aktiv === 'konten' && <Konten />}
        {aktiv === 'dauerauftraege' && <Dauerauftraege />}
        {aktiv === 'protokoll' && <Protokoll />}
        {aktiv === 'benutzer' && <Benutzer angemeldet={ich.benutzername} />}
        {aktiv === 'profil' && <Profil />}
      </main>
    </div>
  )
}
